<template>
  <div>
    <div class="footer2">
      <p class="text-center"><img alt="molise salute" width="280px" src="../../assets/salute.svg" /></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer"
}
</script>

<style scoped>

</style>